import {useCustomQuery} from '@salesforce/commerce-sdk-react'

const useCustomerSearch = (email, enable) => {
    return useCustomQuery(
        {
            options: {
                method: 'GET',
                customApiPathParameters: {
                    apiName: 'customer-search',
                    apiVersion: 'v1',
                    endpointPath: 'searchCustomer'
                },
                parameters: {
                    c_customerEmail: email
                }
            }
        },
        {
            enabled: enable
        }
    )
}

export default useCustomerSearch
